import { NavLink } from "react-router-dom";
import { TrendingUp, Zap, Wallet, User } from "lucide-react";

const items = [
  { label: "Markets", icon: TrendingUp, to: "/", testid: "nav-markets" },
  { label: "Trade", icon: Zap, to: "/trade", testid: "nav-trade" },
  { label: "Wallet", icon: Wallet, to: "/wallet", testid: "nav-wallet" },
  { label: "Account", icon: User, to: "/profile", testid: "nav-profile" },
];

export function BottomNav() {
  return (
    <nav
      className="bottom-navigation fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-50 border-t border-[#1E293B] bg-[#0B0E14]/95 backdrop-blur-xl flex"
      data-testid="bottom-nav"
    >
      {items.map(({ label, icon: Icon, to, testid }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          data-testid={testid}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center gap-1 text-[10px] font-medium transition-colors ${
              isActive ? "text-[#00E676]" : "text-slate-500 hover:text-slate-300"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Icon size={20} strokeWidth={isActive ? 2.4 : 2} />
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
